/**
 * Query key factory for LLM models and org defaults.
 * Follows the same pattern as llm-providers.keys.ts.
 */
export const llmModelKeys = {
  all: ["llm-models"] as const,
  lists: () => [...llmModelKeys.all, "list"] as const,
  byProvider: (providerId: string) => [...llmModelKeys.lists(), "provider", providerId] as const,
  system: () => [...llmModelKeys.lists(), "system"] as const,
  details: () => [...llmModelKeys.all, "detail"] as const,
  detail: (id: string) => [...llmModelKeys.details(), id] as const,
  orgDefaults: () => [...llmModelKeys.all, "org-defaults"] as const,
  orgDefault: (useCase: string) => [...llmModelKeys.orgDefaults(), useCase] as const,
};
